import React, { useState } from 'react';
import { ContentData } from '../data/contentData';

interface NoticePageProps {
  content: ContentData;
}

interface Notice {
  id: number;
  title: string;
  content: string;
  category: 'important' | 'admission' | 'exam' | 'result' | 'general';
  date: string;
  priority: 'high' | 'medium' | 'low';
  isNew: boolean;
  attachment?: string;
}

const NoticePage: React.FC<NoticePageProps> = ({ content }) => {
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const [selectedNotice, setSelectedNotice] = useState<Notice | null>(null);

  // Notice data
  const notices: Notice[] = [
    {
      id: 1,
      title: '২০২৫ সালের ভর্তি কার্যক্রম শুরু',
      content: 'রাজউক কলেজে ২০২৫ শিক্ষাবর্ষের ভর্তি কার্যক্রম আগামী ১ জানুয়ারি থেকে শুরু হবে। ভর্তির জন্য প্রয়োজনীয় কাগজপত্র ও আবেদন ফরমের বিস্তারিত তথ্য অফিস থেকে সংগ্রহ করা যাবে।',
      category: 'admission',
      date: '২০২৪-১২-২৮',
      priority: 'high',
      isNew: true,
      attachment: 'admission-form-2025.pdf'
    },
    {
      id: 2,
      title: 'এস.এস.সি. পরীক্ষার ফলাফল প্রকাশ',
      content: '২০২৪ সালের এস.এস.সি. পরীক্ষার ফলাফল আগামী ৩০ ডিসেম্বর প্রকাশিত হবে। শিক্ষার্থীরা কলেজ অফিস থেকে ফলাফল সংগ্রহ করতে পারবেন। অনলাইনেও ফলাফল দেখা যাবে।',
      category: 'result',
      date: '২০২৪-১২-২৫',
      priority: 'high',
      isNew: true
    },
    {
      id: 3,
      title: 'বার্ষিক ক্রীড়া দিবসের আয়োজন',
      content: 'আগামী ১৫ জানুয়ারি বার্ষিক ক্রীড়া দিবস উদযাপিত হবে। সকল শিক্ষার্থী, শিক্ষক ও অভিভাবকদের সাদর আমন্ত্রণ। ক্রীড়া প্রতিযোগিতায় অংশগ্রহণের জন্য নিবন্ধন আবশ্যক।',
      category: 'general',
      date: '২০২৪-১২-২০',
      priority: 'medium',
      isNew: false
    },
    {
      id: 4,
      title: 'মিড টার্ম পরীক্ষার সময়সূচি',
      content: '২০২৫ সালের মিড টার্ম পরীক্ষা আগামী ১০ জানুয়ারি থেকে শুরু হবে। পরীক্ষার সময়সূচি ও নিয়মাবলী শিক্ষার্থীদের অবগতির জন্য প্রকাশ করা হলো।',
      category: 'exam',
      date: '২০২৪-১২-১৮',
      priority: 'high',
      isNew: false,
      attachment: 'midterm-schedule-2025.pdf'
    },
    {
      id: 5,
      title: 'শীতকালীন ছুটির ঘোষণা',
      content: 'শীতকালীন ছুটি আগামী ২৫ ডিসেম্বর থেকে ৩ জানুয়ারি পর্যন্ত। কলেজ ৪ জানুয়ারি থেকে স্বাভাবিক কার্যক্রম শুরু হবে।',
      category: 'general',
      date: '২০২৪-১২-১৫',
      priority: 'medium',
      isNew: false
    },
    {
      id: 6,
      title: 'নতুন শিক্ষক নিয়োগ',
      content: 'রাজউক কলেজে পদার্থবিজ্ঞান ও রসায়ন বিভাগে নতুন শিক্ষক নিয়োগ দেওয়া হয়েছে। শিক্ষার্থীরা নতুন শিক্ষকদের সাথে পরিচিত হতে পারবেন।',
      category: 'general',
      date: '২০২৪-১২-১২',
      priority: 'low',
      isNew: false
    },
    {
      id: 7,
      title: 'লাইব্রেরি সময়সূচি পরিবর্তন',
      content: 'কলেজ লাইব্রেরির সময়সূচি পরিবর্তন করা হয়েছে। নতুন সময়সূচি: সকাল ৮টা থেকে বিকাল ৫টা পর্যন্ত।',
      category: 'general',
      date: '২০২৪-১২-১০',
      priority: 'low',
      isNew: false
    },
    {
      id: 8,
      title: 'বিজ্ঞান মেলার আয়োজন',
      content: 'আগামী ২০ জানুয়ারি বার্ষিক বিজ্ঞান মেলা অনুষ্ঠিত হবে। শিক্ষার্থীরা তাদের বিজ্ঞান প্রজেক্ট প্রদর্শন করতে পারবেন।',
      category: 'general',
      date: '২০২৪-১২-০৮',
      priority: 'medium',
      isNew: false
    },
    {
      id: 9,
      title: 'ভর্তি ফি পরিশোধের শেষ তারিখ',
      content: '২০২৫ সালের ভর্তি ফি পরিশোধের শেষ তারিখ ৩১ জানুয়ারি। নির্ধারিত সময়ের মধ্যে ফি পরিশোধ না করলে ভর্তি বাতিল হয়ে যাবে।',
      category: 'admission',
      date: '২০২৪-১২-০৫',
      priority: 'high',
      isNew: false
    },
    {
      id: 10,
      title: 'সাংস্কৃতিক অনুষ্ঠানের আয়োজন',
      content: 'পহেলা বৈশাখ উপলক্ষে সাংস্কৃতিক অনুষ্ঠানের আয়োজন করা হয়েছে। শিক্ষার্থীরা অংশগ্রহণের জন্য নিবন্ধন করতে পারবেন।',
      category: 'general',
      date: '২০২৪-১২-০৩',
      priority: 'medium',
      isNew: false
    }
  ];

  const categories = [
    { key: 'all', label: 'সকল নোটিশ', icon: '📋' },
    { key: 'important', label: 'গুরুত্বপূর্ণ', icon: '⚠️' },
    { key: 'admission', label: 'ভর্তি', icon: '📝' },
    { key: 'exam', label: 'পরীক্ষা', icon: '📚' },
    { key: 'result', label: 'ফলাফল', icon: '📊' },
    { key: 'general', label: 'সাধারণ', icon: '📢' }
  ];

  const filteredNotices = selectedCategory === 'all' 
    ? notices 
    : notices.filter(notice => notice.category === selectedCategory);

  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'high': return 'text-red-600 bg-red-100';
      case 'medium': return 'text-yellow-600 bg-yellow-100';
      case 'low': return 'text-green-600 bg-green-100';
      default: return 'text-gray-600 bg-gray-100';
    }
  };

  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'important': return 'border-red-500 bg-red-50';
      case 'admission': return 'border-blue-500 bg-blue-50';
      case 'exam': return 'border-purple-500 bg-purple-50';
      case 'result': return 'border-green-500 bg-green-50';
      case 'general': return 'border-gray-500 bg-gray-50';
      default: return 'border-gray-300 bg-white';
    }
  };

  return (
    <div className="py-16 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4 bangla-font">{content.notice.title}</h1>
          <p className="text-lg text-gray-600 bangla-font">সর্বশেষ নোটিশ ও ঘোষণা</p>
        </div>

        {/* Category Filter */}
        <div className="mb-8">
          <div className="flex flex-wrap justify-center gap-2">
            {categories.map((category) => (
              <button
                key={category.key}
                onClick={() => setSelectedCategory(category.key)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                  selectedCategory === category.key
                    ? 'bg-blue-600 text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-blue-50 border border-gray-300'
                }`}
              >
                <span className="mr-2">{category.icon}</span>
                <span className="bangla-font">{category.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Notices Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredNotices.map((notice) => (
            <div
              key={notice.id}
              className={`bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer transform hover:-translate-y-1 border-l-4 ${getCategoryColor(notice.category)}`}
              onClick={() => setSelectedNotice(notice)}
            >
              <div className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-center space-x-2">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(notice.priority)}`}>
                      {notice.priority === 'high' ? 'উচ্চ' : notice.priority === 'medium' ? 'মধ্যম' : 'নিম্ন'}
                    </span>
                    {notice.isNew && (
                      <span className="px-2 py-1 bg-red-500 text-white text-xs font-medium rounded-full">
                        নতুন
                      </span>
                    )}
                  </div>
                  <span className="text-xs text-gray-500 bangla-font">{notice.date}</span>
                </div>
                
                <h3 className="text-lg font-semibold text-gray-900 mb-3 bangla-font line-clamp-2">
                  {notice.title}
                </h3>
                
                <p className="text-gray-600 text-sm mb-4 bangla-font line-clamp-3">
                  {notice.content}
                </p>
                
                <div className="flex items-center justify-between">
                  <span className="text-xs px-2 py-1 bg-gray-100 text-gray-700 rounded-full">
                    {categories.find(cat => cat.key === notice.category)?.label}
                  </span>
                  {notice.attachment && (
                    <span className="text-xs text-blue-600 flex items-center">
                      📎 সংযুক্তি
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* No Notices Message */}
        {filteredNotices.length === 0 && (
          <div className="text-center py-16">
            <div className="text-6xl mb-4">📋</div>
            <h3 className="text-xl font-semibold text-gray-700 mb-2 bangla-font">কোন নোটিশ পাওয়া যায়নি</h3>
            <p className="text-gray-500 bangla-font">অনুগ্রহ করে অন্য ক্যাটাগরি নির্বাচন করুন</p>
          </div>
        )}

        {/* Notice Modal */}
        {selectedNotice && (
          <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="flex justify-between items-start mb-6">
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-2 bangla-font">{selectedNotice.title}</h2>
                    <div className="flex items-center space-x-4 text-sm text-gray-500">
                      <span className="bangla-font">তারিখ: {selectedNotice.date}</span>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(selectedNotice.priority)}`}>
                        {selectedNotice.priority === 'high' ? 'উচ্চ অগ্রাধিকার' : selectedNotice.priority === 'medium' ? 'মধ্যম অগ্রাধিকার' : 'নিম্ন অগ্রাধিকার'}
                      </span>
                    </div>
                  </div>
                  <button
                    onClick={() => setSelectedNotice(null)}
                    className="text-gray-500 hover:text-gray-700 text-2xl"
                  >
                    ✕
                  </button>
                </div>
                
                <div className="prose max-w-none mb-6">
                  <p className="text-gray-700 leading-relaxed bangla-font">{selectedNotice.content}</p>
                </div>
                
                {selectedNotice.attachment && (
                  <div className="border-t pt-4">
                    <h4 className="font-semibold text-gray-900 mb-2 bangla-font">সংযুক্তি:</h4>
                    <a
                      href={`/downloads/${selectedNotice.attachment}`}
                      className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                    >
                      📎 {selectedNotice.attachment}
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Statistics */}
        <div className="mt-16 bg-white rounded-lg p-8 shadow-lg">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center bangla-font">নোটিশ পরিসংখ্যান</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">{notices.length}</div>
              <div className="text-gray-600 bangla-font">মোট নোটিশ</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-red-600 mb-2">{notices.filter(n => n.priority === 'high').length}</div>
              <div className="text-gray-600 bangla-font">গুরুত্বপূর্ণ</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-green-600 mb-2">{notices.filter(n => n.isNew).length}</div>
              <div className="text-gray-600 bangla-font">নতুন নোটিশ</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-purple-600 mb-2">{categories.length - 1}</div>
              <div className="text-gray-600 bangla-font">ক্যাটাগরি</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoticePage;
